import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Add this import
import AuthApiService from '../../ApiServices/AuthApiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SigninWithGoogleRequest from "../../Models/SignInWithGoogleRequest";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useAuth } from "./AuthContext";
import { auth, provider, signInWithPopup } from "./firebase-config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";


export default function Signup() {
    const navigate = useNavigate();
    let location = useLocation();
    let userInfo = location.state ?? new SigninWithGoogleRequest();
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState("");
    const { setAuthInfo } = useAuth();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (password !== confirmPassword) {
            setLoading(false);
            return;
        }

        try {
            let result;
            // will be null if it's simple sign up but not with google sign up.
            if (userInfo.UserName == null || userInfo.UserName == undefined) {
                result = await handleDefaultSignup();
            } else {
                //after google sign, provide further info
                result = await handleGoogleSignup();
            }
            toast(result.message);
            if (result.isSuccess) {
                //redirect to login
                navigate("/");
            }
        } catch (error) {
            toast(error.message);
            console.error('Signup error:', error);
        } finally {
            setLoading(false);
        }
    };

    // 🔹 Google Sign-In
    const handleGoogleSignIn = async () => {
        setLoading(true);
        setErrorMessage("");

        try {
            const result = await signInWithPopup(auth, provider);

            const user = result.user;
            const credentials = {
                username: user.email,
                password: "GoogleOAuth", // Optional placeholder for Google login
                rememberMe: true,
            };

            const UserDetail = await AuthApiService.checkUserByEmail(credentials);

            if (UserDetail && UserDetail.isSuccess) {
                const user = UserDetail.data.user;
                const role = UserDetail.data.roles;
                setAuthInfo(user, role);
                navigate("/home");
            } else {
                const signInWithGoogleRequest = new SigninWithGoogleRequest(
                    result.user.email,
                    result._tokenResponse.firstName,
                    result._tokenResponse.lastName
                );

                await AuthApiService.signInWithGoogle(signInWithGoogleRequest);
                navigate("/signup", { state: signInWithGoogleRequest });
                alert("Please fill in the details and then log in.");
            }
        } catch (error) {
            setErrorMessage("Failed to sign in. Please try again.");
            console.error("Error during sign-in:", error);
        } finally {
            setLoading(false);
        }
    };

    async function handleDefaultSignup() {
        const signupData = {
            username: document.getElementById('first-name').value,
            email: userInfo?.UserName ?? document.getElementById('email').value,
            password: password,
            firstName: document.getElementById('first-name').value,
            lastName: document.getElementById('last-name').value,
            company: document.getElementById('company').value,
            phone: document.getElementById('phone').value,
        };
        return await AuthApiService.signup(signupData);
    }
    async function handleGoogleSignup() {
        const signupData = {
            // Username: document.getElementById('first-name').value,
            //TODO : sending skype as username for now but need to be changed later.
            Skype: userInfo.UserName,
            Email: userInfo.UserName,
            Password: password,
            CompanyName: document.getElementById('company').value,
            PhoneNo: document.getElementById('phone').value,
        };
        return await AuthApiService.RegisterUser(signupData);

    }

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const images = [
        "/Images/Login/dashboard1.jpeg",
        "/Images/Login/dashboard2.jpeg",
        "/Images/Login/dashboard3.jpeg",
    ]; // Replace with actual images
    const awards = [
        {
            imageUrl: './Images/Award1.png',
            altText: 'Award 1',
        },
        {
            imageUrl: './Images/Award2.png',
            altText: 'Award 2',
        },
        {
            imageUrl: './Images/Award3.png',
            altText: 'Award 3',
        },
    ];
    return (
        <div
            className="min-h-screen flex flex-col items-center justify-center p-6 bg-cover bg-center"
            style={{ backgroundImage: "url('/Images/Logos/background.jpg')" }}
        >
            <div className="flex flex-wrap w-11/12 max-w-7xl justify-center gap-12">
                {/* Left Side - Slider Section */}
                <div className="w-full md:w-[50%] bg-white shadow-xl rounded-2xl p-6">
                    <div className="max-w-7xl mx-auto px-6 lg:px-8">
                        <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 justify-items-center">
                            {awards.map((award, index) => (
                                <div key={index} className="flex justify-center" data-aos="fade-up" data-aos-delay={`${index === 1 ? 0 : (index + 1) * 200}`}>
                                    <a href="/#" className="no-underline">
                                        <img
                                            src={award.imageUrl}
                                            alt={award.altText}
                                            className="h-24 object-contain transition-transform transform hover:scale-105 mx-auto"
                                        />
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex flex-col items-center">
                        <Slider {...sliderSettings} className="w-full max-w-lg h-full">
                            {images.map((image, index) => (
                                <div key={index} className="flex justify-center w-full">
                                    <img
                                        src={image}
                                        alt={`Slide ${index + 1}`}
                                        className="w-full h-[65vh] rounded-lg shadow-md object-cover"
                                    />
                                </div>
                            ))}
                        </Slider>
                        {/* Text Below Slider */}
                        <div className="mt-6 text-center px-4">
                            <h1 className="text-2xl font-semibold text-gray-900">
                                Access a Large Pool of Advertisers
                            </h1>
                            <p className="text-gray-600 mt-2">
                                Adx has strict criteria for advertisers, leading to better competition and higher revenue per ad impression.
                            </p>
                        </div>
                        <div className="flex flex-wrap items-center justify-center gap-4">
                            <img
                                src="./Images/logos/trustpilot-scraper-tutorial.png"
                                className=" object-contain max-w-full"
                                alt="Trustpilot Excellent Score"
                            />
                            <img
                                src="./Images/logos/googlepartner.png"
                                className="h-16 md:h-20 lg:h-24 object-contain max-w-full"
                                alt="Google Partner"
                            />
                        </div>

                    </div>
                </div>

                {/* Right Side - Form Section */}
                <div className="w-full md:w-[45%] bg-white shadow-xl rounded-2xl p-8">
                    <div className="flex justify-center items-center bg-gray-100">
                        <img
                            src="./Images/logos/weblogo.png"
                            className="h-16 md:h-20 lg:h-24 object-contain max-w-full"
                            alt="Google Partner"
                        />
                    </div>
                    <div className="max-w-md w-full mx-auto">
                        <h1 className="text-3xl font-bold text-gray-900 text-center">
                            Create an Account
                        </h1>
                        <p className="text-sm text-gray-500 font-medium mt-2 text-center">
                            Already have an account?{" "}
                            <Link to="/" className="text-purple-600 font-semibold hover:underline">
                                Sign in
                            </Link>
                        </p>
                        <button
                            onClick={handleGoogleSignIn}
                            className="mt-6 flex items-center justify-center w-full bg-white border border-gray-300 rounded-lg shadow-sm px-4 py-3 hover:bg-gray-100 transition"
                        >
                            <img src="/Images/gog.png" alt="Google" className="h-5 w-5 mr-2" />
                            <span className="text-gray-700 font-medium">Sign Up with Google</span>
                        </button>
                        {/* Divider */}
                        <div className="relative mt-6 flex items-center justify-center">
                            <div className="w-full h-px bg-gray-300"></div>
                            <span className="absolute px-4 bg-white text-gray-500">Or</span>
                        </div>

                        <form className="space-y-5 mt-6" onSubmit={handleSignup}>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">
                                        First Name <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        id="first-name"
                                        type="text"
                                        value={userInfo.FirstName}
                                        required
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                        placeholder="John"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">
                                        Last Name <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        id="last-name"
                                        type="text"
                                        required
                                        value={userInfo.LastName}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                        placeholder="Doe"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Company
                                </label>
                                <input
                                    id="company"
                                    type="text"
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                    placeholder="Company Name"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Email <span className="text-red-500">*</span>
                                </label>
                                <input
                                    id="email"
                                    type="email"
                                    required
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                    placeholder="someone@gmail.com"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Phone <span className="text-red-500">*</span>
                                </label>
                                <input
                                    id="phone"
                                    type="tel"
                                    required
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                    placeholder="123-456-7890"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Skype
                                </label>
                                <input
                                    id="skype"
                                    type="text"
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                    placeholder="Skype ID"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Password <span className="text-orange-500">*</span>
                                </label>
                                <div className="relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        required
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:outline-none"
                                        placeholder="••••••••••••••••"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        onClick={togglePasswordVisibility}
                                        className="absolute inset-y-0 right-3 flex items-center"
                                    >
                                        <FontAwesomeIcon
                                            icon={showPassword ? faEyeSlash : faEye}
                                            className="w-5 h-5 text-gray-500"
                                        />
                                    </button>
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Confirm Password <span className="text-orange-500">*</span>
                                </label>
                                <div className="relative">
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        required
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:outline-none"
                                        placeholder="••••••••••••••••"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        onClick={toggleConfirmPasswordVisibility}
                                        className="absolute inset-y-0 right-3 flex items-center"
                                    >
                                        <FontAwesomeIcon
                                            icon={showConfirmPassword ? faEyeSlash : faEye}
                                            className="w-5 h-5 text-gray-500"
                                        />
                                    </button>
                                </div>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-gradient-to-r from-purple-600 to-purple-800 text-white py-3 rounded-lg font-semibold hover:shadow-lg transition"
                            >
                                {loading ? "Signing Up..." : "Sign Up"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );

}

